import React from 'react';
import { Button, Input, Select } from 'antd';
import { CalendarOutlined, BankOutlined, TagsOutlined, GlobalOutlined, ProjectOutlined, UserOutlined, ToolOutlined, SettingOutlined, ApartmentOutlined, BulbOutlined, NumberOutlined, EyeOutlined, MobileOutlined } from '@ant-design/icons';
import { DateRangePicker } from 'react-date-range';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import FilterSelect from '../../UI/filterSelect';
import DateRangeFilter from '../../UI/DateRangeFilter';

dayjs.extend(utc);

const { Option } = Select;

const AnalyticsHeader = ({ 
  pickerRef, 
  selectedRange, 
  togglePicker, 
  pickerOpen, 
  handleDateChange,
  organizationsList,
  selectedOrganizations,
  handleOrganizationChange,
  activeTab,
  activeInnerTab,
  selectedSource,
  selectedMedium,
  handleSourceChange,
  handleMediumChange,
  handleClearFilters,
  leads_sources,
  lead_medium,
  filtersLoading,
  showUniqueData,
  setShowUniqueData,
  selectedCustomerType,
  handleCustomerTypeChange,
  trades,
  services,
  jobs,
  selectedTrade,
  handleTradeChange,
  selectedServiceType,
  handleServiceTypeChange,
  selectedJobType,
  handleJobTypeChange,
  customerJourneyDataView,
  handleCustomerJourneyDataViewChange,
  selectedBookingType,
  handleBookingTypeChange,
  selectedCampaign,
  handleCampaignChange,
  lead_campaigns,
  selectedDeviceType,
  handleDeviceTypeChange
}) => {
  const handleSelectAll = () => {
    const allOrgIds = organizationsList.map(org => org._id);
    handleOrganizationChange(allOrgIds);
  };

  const handleUnselectAll = () => {
    handleOrganizationChange([]);
  };

  const handleOrganizationSelect = (value, option) => {
    if (value === 'SELECT_ALL') {
      handleSelectAll();
      return;
    }
    if (value === 'UNSELECT_ALL') {
      handleUnselectAll();
      return;
    }
    handleOrganizationChange(value);
  };

  return (
    <div style={{ 
      marginBottom: '12px',
      backgroundColor: '#fff',
      borderRadius: '6px',
      border: '1px solid #e2e8f0',
      padding: '12px',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)'
    }}>
      <div style={{ 
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        justifyContent: 'space-between'
      }}>
        <div style={{ 
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px',
          alignItems: 'flex-start',
          flex: 1
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
            minWidth: '300px',
            maxWidth: '450px',
            flex: '0 1 auto'
          }}>
          <div style={{ 
            fontSize: '12px', 
            fontWeight: '600', 
            color: '#4b5563',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}>
            <BankOutlined style={{ fontSize: '12px', color: '#6b7280' }} />
            <span>Organizations ({selectedOrganizations?.length || 0})</span>
          </div>
          
          <Select
            mode="multiple"
            placeholder="Select organizations"
            value={selectedOrganizations}
            onChange={handleOrganizationSelect}
            maxTagCount={1}
            allowClear
            showSearch
            optionFilterProp="children"
            className="org-select"
            size="small"
            style={{ width: '100%',minHeight: '24px'}}
            dropdownRender={(menu) => (
              <>
                <div style={{ padding: '4px 8px', borderBottom: '1px solid #f0f0f0' }}>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <Button 
                      size="small" 
                      type="link"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSelectAll();
                      }}
                      style={{ 
                        fontSize: '11px',
                        padding: '0',
                        height: 'auto',
                        color: '#1890ff'
                      }}
                    >
                      ✓ Select All
                    </Button>
                    <Button 
                      size="small" 
                      type="link"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleUnselectAll();
                      }}
                      style={{ 
                        fontSize: '11px',
                        padding: '0',
                        height: 'auto',
                        color: '#ff4d4f'
                      }}
                    >
                      ✗ Clear All
                    </Button>
                  </div>
                </div>
                {menu}
              </>
            )}
          >
            {organizationsList
              ?.slice()
              ?.sort((a, b) => (a?.organization_name || "")?.localeCompare(b?.organization_name || ""))
              ?.map((org) => (
                <Option key={org._id} value={org._id}>
                  {org.organization_name || org.name || "Unnamed Organization"}
                </Option>
              ))
            }
          </Select>
        </div>



        {/* Source Filter */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '6px',
          minWidth: 'fit-content'
        }}>
          <div style={{ 
            fontSize: '12px', 
            fontWeight: '600', 
            color: '#4b5563',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}>
            <TagsOutlined style={{ fontSize: '12px', color: '#6b7280' }} />
            <span>Source</span>
          </div>
          
          <FilterSelect
            value={selectedSource}
            onChange={handleSourceChange}
            options={leads_sources}
            placeholder="All Sources"
            loading={filtersLoading}
            selectWidth="140px"
          />
        </div>

        {/* Medium Filter */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '6px',
          minWidth: 'fit-content'
        }}>
          <div style={{ 
            fontSize: '12px', 
            fontWeight: '600', 
            color: '#4b5563',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}>
            <GlobalOutlined style={{ fontSize: '12px', color: '#6b7280' }} />
            <span>Medium</span>
          </div>
          
          <FilterSelect
            value={selectedMedium}
            onChange={handleMediumChange}
            options={lead_medium}
            placeholder="All Mediums"
            loading={filtersLoading}
            selectWidth="140px"
          />
        </div>

        {/* Campaign Filter */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '6px',
          minWidth: 'fit-content'
        }}>
          <div style={{ 
            fontSize: '12px', 
            fontWeight: '600', 
            color: '#4b5563',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}>
            <ProjectOutlined style={{ fontSize: '12px', color: '#6b7280' }} />
            <span>Campaign</span>
          </div>
          
          <FilterSelect
            value={selectedCampaign}
            onChange={handleCampaignChange}
            options={lead_campaigns || []}
            placeholder="All Campaigns"
            loading={filtersLoading}
            selectWidth="160px"
          />
        </div>

        {/* Device Type Filter */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '6px',
          minWidth: 'fit-content'
        }}>
          <div style={{ 
            fontSize: '12px', 
            fontWeight: '600', 
            color: '#4b5563',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}>
            <MobileOutlined style={{ fontSize: '12px', color: '#6b7280' }} />
            <span>Device Type</span>
          </div>
          
          <FilterSelect
            value={selectedDeviceType}
            onChange={handleDeviceTypeChange}
            options={[
              { value: "desktop", label: "Desktop" },
              { value: "mobile", label: "Mobile" }
            ]}
            placeholder="All Devices"
            selectWidth="140px"
          />
        </div>

        {/* Conditional filters based on activeTab */}
        {(activeTab === 'overview' || activeTab === 'analysis') && (
          <>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '6px',
              minWidth: 'fit-content'
            }}>
              <div style={{ 
                fontSize: '12px', 
                fontWeight: '600', 
                color: '#4b5563',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <UserOutlined style={{ fontSize: '12px', color: '#6b7280' }} />
                <span>Customer Type</span>
              </div>
              
              <FilterSelect
                value={selectedCustomerType}
                onChange={handleCustomerTypeChange}
                options={[
                  { value: "Existing Customer", label: "Existing Customer" },
                  { value: "New Customer", label: "New Customer" }
                ]}
                placeholder="All Customer Types"
                selectWidth="150px"
              />
            </div>
            
            {/* Data Type Filter */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '6px',
              minWidth: 'fit-content'
            }}>
              <div style={{ 
                fontSize: '12px', 
                fontWeight: '600', 
                color: '#4b5563',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <NumberOutlined style={{ fontSize: '12px', color: '#6b7280' }} />
                <span>Customer Count</span>
              </div>
              
              <Select
                value={showUniqueData ? 'unique' : 'total'}
                onChange={(value) => setShowUniqueData(value === 'unique')}
                size="small"
                style={{ width: '140px' }}
              >
                <Option value="total">Total</Option>
                <Option value="unique">Unique</Option>
              </Select>
            </div>
          </>
        )}
        
        {/* Trade Analysis - Customer Journey specific filters */}
        {(activeTab === 'trade_analysis' && activeInnerTab === 'customer_journey') && (
          <>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '6px',
              minWidth: 'fit-content'
            }}>
              <div style={{ 
                fontSize: '12px', 
                fontWeight: '600', 
                color: '#4b5563',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <ToolOutlined style={{ fontSize: '12px', color: '#6b7280' }} />
                <span>Trade</span>
              </div>
              
              <FilterSelect
                value={selectedTrade}
                onChange={handleTradeChange}
                options={trades?.map(trade => ({ value: trade._id, label: trade.tradeName })) || []}
                placeholder="All Trades"
                selectWidth="140px"
              />
            </div>
            
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '6px',
              minWidth: 'fit-content'
            }}>
              <div style={{ 
                fontSize: '12px', 
                fontWeight: '600', 
                color: '#4b5563',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <SettingOutlined style={{ fontSize: '12px', color: '#6b7280' }} />
                <span>Service</span>
              </div>
              
              <FilterSelect
                value={selectedServiceType}
                onChange={handleServiceTypeChange}
                options={services?.map(service => ({ value: service.id, label: service.name })) || []}
                placeholder="All Services"
                selectWidth="140px"
              />
            </div>
            
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '6px',
              minWidth: 'fit-content'
            }}>
              <div style={{ 
                fontSize: '12px', 
                fontWeight: '600', 
                color: '#4b5563',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <ApartmentOutlined style={{ fontSize: '12px', color: '#6b7280' }} />
                <span>Equipment Type</span>
              </div>
              
              <FilterSelect
                value={selectedJobType}
                onChange={handleJobTypeChange}
                options={jobs?.map(job => ({ value: job._id, label: job.jobItem })) || []}
                placeholder="All Equipment Types"
                selectWidth="160px"
              />
            </div>
            
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '6px',
              minWidth: 'fit-content'
            }}>
              <div style={{ 
                fontSize: '12px', 
                fontWeight: '600', 
                color: '#4b5563',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <BulbOutlined style={{ fontSize: '12px', color: '#6b7280' }} />
                <span>Session Type</span>
              </div>
              
              <FilterSelect
                value={selectedBookingType}
                onChange={handleBookingTypeChange}
                options={[
                  { value: "standard", label: "Standard" },
                  { value: "custom", label: "Quick Link" }
                ]}
                placeholder="All Session Types"
                selectWidth="130px"
              />
            </div>
            
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '6px',
              minWidth: 'fit-content'
            }}>
              <div style={{ 
                fontSize: '12px', 
                fontWeight: '600', 
                color: '#4b5563',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <UserOutlined style={{ fontSize: '12px', color: '#6b7280' }} />
                <span>Customer Type</span>
              </div>
              
              <FilterSelect
                value={selectedCustomerType}
                onChange={handleCustomerTypeChange}
                options={[
                  { value: "Existing Customer", label: "Existing Customer" },
                  { value: "New Customer", label: "New Customer" }
                ]}
                placeholder="All Customer Types"
                selectWidth="150px"
              />
            </div>
            
            {/* Data View Filter */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '6px',
              minWidth: 'fit-content'
            }}>
              <div style={{ 
                fontSize: '12px', 
                fontWeight: '600', 
                color: '#4b5563',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <EyeOutlined style={{ fontSize: '12px', color: '#6b7280' }} />
                <span>Lead Type</span>
              </div>
              
              <Select
                value={customerJourneyDataView}
                onChange={handleCustomerJourneyDataViewChange}
                size="small"
                style={{ minWidth: '110px' }}
              >
                <Option value="all">All Leads</Option>
                <Option value="abandoned">Abandoned</Option>
                <Option value="booked">Booked</Option>
              </Select>
            </div>
          </>
        )}
        
        {/* Trade Analysis - Page Abandonment specific filters */}
        {(activeTab === 'trade_analysis' && activeInnerTab === 'page_based') && (
          <>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '6px',
              minWidth: 'fit-content'
            }}>
              <div style={{ 
                fontSize: '12px', 
                fontWeight: '600', 
                color: '#4b5563',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <BulbOutlined style={{ fontSize: '12px', color: '#6b7280' }} />
                <span>Session Type</span>
              </div>
              
              <FilterSelect
                value={selectedBookingType}
                onChange={handleBookingTypeChange}
                options={[
                  { value: "standard", label: "Standard" },
                  { value: "custom", label: "Quick Link" }
                ]}
                placeholder="All Lead Types"
                selectWidth="130px"
              />
            </div>
            
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '6px',
              minWidth: 'fit-content'
            }}>
              <div style={{ 
                fontSize: '12px', 
                fontWeight: '600', 
                color: '#4b5563',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <UserOutlined style={{ fontSize: '12px', color: '#6b7280' }} />
                <span>Customer Type</span>
              </div>
              
              <FilterSelect
                value={selectedCustomerType}
                onChange={handleCustomerTypeChange}
                options={[
                  { value: "Existing Customer", label: "Existing Customer" },
                  { value: "New Customer", label: "New Customer" }
                ]}
                placeholder="All Customer Types"
                selectWidth="150px"
              />
            </div>
          </>
        )}
        
        {(() => {
          const hasFiltersApplied = selectedSource || 
                                  selectedMedium || 
                                  selectedCustomerType ||
                                  selectedTrade ||
                                  selectedServiceType ||
                                  selectedJobType ||
                                  selectedCampaign ||
                                  selectedBookingType ||
                                  selectedDeviceType ||
                                  (selectedRange && selectedRange[0] && 
                                   (dayjs(selectedRange[0].startDate).format('YYYY-MM-DD') !== dayjs().startOf('month').format('YYYY-MM-DD') ||
                                    dayjs(selectedRange[0].endDate).format('YYYY-MM-DD') !== dayjs().endOf('month').format('YYYY-MM-DD')))
          
          return hasFiltersApplied && (
            <Button 
              onClick={handleClearFilters} 
              size="small"
              type="default"
              style={{ 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '4px',
                height: '24px',
                fontSize: '12px',
                border: '1px solid #e2e8f0',
                borderRadius: '4px',
                backgroundColor: '#fff',
                color: '#6b7280',
                minWidth: 'fit-content',
                alignSelf: 'flex-end'
              }}
            >
              🔄 Clear Filters
            </Button>
          );
        })()}
        </div>
        <DateRangeFilter
          selectedRange={selectedRange}
          togglePicker={togglePicker}
          pickerOpen={pickerOpen}
          handleDateChange={handleDateChange}
          pickerRef={pickerRef}
          containerStyle={{
            minHeight: '40px',
            minWidth: '190px',
            left:0,
          }}
          disabledDay={(date) => {
            const july2025 = dayjs('2025-07-01');
            return dayjs(date).isBefore(july2025);
          }}
        />
      </div>
    </div>
  );
};

export default AnalyticsHeader; 